import { put } from "redux-saga/effects";
import * as actions from '../actions'

export function* getLoader(){
  try {
    yield put(actions.setLoader(false))
  } catch (error) {
    console.log(error.response.data);
  }
}